import { LEAD_TIME_FORMAT, ProductLeadTime } from "@hermes/api-model-product";

import {
    LeadTimeFrom,
    LeadTimeFromTo,
    LeadTimeGeneric,
    LeadTimeShippingDate,
    LeadTimeTo,
} from "../types/lead-time.type";

export const isLeadTimeFrom = (
    leadTime: ProductLeadTime,
): leadTime is LeadTimeFrom => leadTime.format === LEAD_TIME_FORMAT.FROM;

export const isLeadTimeFromTo = (
    leadTime: ProductLeadTime,
): leadTime is LeadTimeFromTo => leadTime.format === LEAD_TIME_FORMAT.FROM_TO;

export const isLeadTimeTo = (
    leadTime: ProductLeadTime,
): leadTime is LeadTimeTo => leadTime.format === LEAD_TIME_FORMAT.TO;

export const isLeadTimeShippingDate = (
    leadTime: ProductLeadTime,
): leadTime is LeadTimeShippingDate =>
    leadTime.format === LEAD_TIME_FORMAT.DATE;

export const isLeadTimeGeneric = (
    leadTime: ProductLeadTime,
): leadTime is LeadTimeGeneric => leadTime.format === LEAD_TIME_FORMAT.DEFAULT;
